import { Component, ChangeDetectionStrategy, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { ProductReservation } from '@vestiaire/api-sdk-angular/model/productReservation';
import { ChatUser } from '@vestiaire/api-sdk-angular';
import { ChatService } from '@app/+chat/services/chat.service';

@Component({
  selector: 'vc-chat-form',
  templateUrl: './chat-form.component.html',
  styleUrls: ['./chat-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatFormComponent {
  @Input() isReserved: boolean;
  @Input() reservation: ProductReservation;
  @Input() senderIsBlocked: boolean;
  @Input() receiverIsBlocked: boolean;
  @Input() receiverIsBanned: boolean;
  @Input() senderIsBanned: boolean;
  @Input() receiverInfo: ChatUser;
  @Output() sendMsgTracking: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('chatMsg', { read: ElementRef, static: false }) chatMsgInput: ElementRef;
  @ViewChild('chatWrapper', { read: ElementRef, static: true }) chatWrapper: ElementRef;

  timeout = null;
  currentMessage = '';
  limitCharacter = 500;

  constructor(private chatService: ChatService) {}

  adjustToContent() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.chatMsgInput.nativeElement.style.height = 'auto';
      this.chatMsgInput.nativeElement.style.height = this.chatMsgInput.nativeElement.scrollHeight + 'px';
      this.scrollToBottom();
    }, 300);
  }

  onSubmit() {
    if (this.currentMessage.length < this.limitCharacter) {
      this.sendMsgTracking.emit();
      this.chatService.onSendMessage(this.currentMessage);
      this.currentMessage = '';
      this.chatMsgInput.nativeElement.style.height = 'auto';
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.chatWrapper.nativeElement.scrollTop = this.chatWrapper.nativeElement.scrollHeight;
      } catch (error) {}
    }, 0);
  }
}
